import { render } from "./TextComponent.vue?vue&type=template&id=5131417c&scoped=true"
const script = {}

import "./TextComponent.vue?vue&type=style&index=0&id=5131417c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5131417c"]])

export default __exports__